import styled from "styled-components"

const Container = styled.div`
  margin: 0 auto;
  max-width: 690px;
`

const Wrapper = styled.section`
  figure {
    img {
      display: block;
      height: auto;
      width: 100%;
    }

    figcaption {
      display: block;
      font-size: 12px;
      margin-top: 5px;
    }
  }
`

const Header = styled.header`
  h1 {
    font-size: 28px;
    font-weight: ${props => props.theme.title.w};
    line-height: 1.2;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 36px;
    }
  }

  span {
    color: ${props => props.theme.colors.lightgrey};
    display: block;
    font-size: 12px;
    line-height: 1.2;
    margin-top: 15px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 14px;
      margin-top: 20px;
    }
  }

  p {
    font-size: 18px;
    font-style: italic;
    line-height: ${props => props.theme.text.lhm};
    margin: 20px 0 0;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 24px;
      line-height: ${props => props.theme.text.lhd};
      margin: 35px 0 0;
    }
  }
`

const Featured = styled.div`
  margin: 40px 0 50px;
  position: relative;

  @media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) {
    margin: 40px -20px 50px;
  }

  @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
    margin: 35px -20px;
  }
`

const Body = styled.article`
  margin-bottom: 35px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin-bottom: 50px;
  }

  ${Container} {
    > div,
    > iframe {
      margin: 35px auto;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        margin: 50px auto;
      }
    }

    > p,
    > ul,
    > ol {
      font-size: ${props => props.theme.text.sm};
      font-weight: ${props => props.theme.text.w};
      line-height: ${props => props.theme.text.lhm};
      margin: 25px 0;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        font-size: ${props => props.theme.text.sd};
        line-height: ${props => props.theme.text.lhd};
        margin: 30px 0;
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    > p {
      a {
        color: ${props => props.theme.colors.primary};
        text-decoration: underline;

        .no-touchevents &:hover {
          text-decoration: none;
        }
      }
    }

    > h2,
    > h3,
    > h4 {
      margin-top: 35px;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        margin-top: 50px;
      }

      + * {
        margin-top: 5px;

        @media only screen and (min-width: ${props => props.theme.mq.small}) {
          margin-top: 10px;
        }
      }
    }

    > h2 {
      font-size: 20px;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        font-size: 24px;
      }
    }

    > h3 {
      font-size: 17px;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        font-size: 21px;
      }
    }

    > ul,
    > ol {
      padding-left: 1em;
    }

    > ul {
      list-style-type: disc;
    }

    strong,
    b,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: ${props => props.theme.title.w};
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      > .anchor {
        margin-right: 5px;

        @media only screen and (min-width: ${props => props.theme.mq.small}) {
          margin-right: 10px;
        }

        svg {
          height: 15px;
          width: 15px;

          @media only screen and (min-width: ${props => props.theme.mq.small}) {
            height: 18px;
            width: 18px;
          }

          path {
            fill: ${props => props.theme.colors.grey};
          }
        }
      }
    }
  }
`

const Footer = styled.div`
  padding: 20px 0 50px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    padding: 20px 0 80px;
  }
`

const Tags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: -5px -5px 25px;

  > li {
    padding: 5px;
  }
`

const Share = styled.div`
  align-items: center;
  display: flex;

  span {
    display: block;
    font-size: 12px;
    margin-right: 15px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 14px;
    }
  }

  button {
    cursor: pointer;
    transition: opacity 0.3s;

    &:not(:last-child) {
      margin-right: 12px;
    }

    .no-touchevents &:hover {
      opacity: 0.7;
    }
  }
`

const Related = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  overflow: hidden;

  > h2 {
    margin: 45px 0 40px;
    font-size: 15px;
    font-weight: ${props => props.theme.title.w};

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 18px;
      margin: 60px 0 50px;
    }
  }

  > ul {
    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      flex-wrap: nowrap;
    }
  }
`

export const sPost = {
  Container,
  Wrapper,
  Header,
  Featured,
  Body,
  Footer,
  Tags,
  Share,
  Related,
}
